import type { PageNumber, PdfiumAPI } from "@pdfking/pdfium"
import type { PDFMergeFunction, PDFMergeInput } from "@pdfking/renderer-api"
import { ProvisionWasm } from "@pdfking/pdfium"
import { AutoThrow } from "../utils/AutoThrow"
import { OpenReader } from "../utils/OpenReader"
import { PDF_HEADER, Recompose } from "../utils/Recompose"

const FLUSH_THRESHOLD = 1024 * 1024

async function* ExtractPages(
  api: PdfiumAPI,
  pages: AsyncIterable<PDFMergeInput> | Iterable<PDFMergeInput>
) {
  let highest_obj_num = 2n
  let bytes_written = BigInt(PDF_HEADER.length)

  for await (const { stream, size, page_number } of pages) {
    const { handle, ensure_page, close } = await OpenReader(api, stream, size)
    try {
      await ensure_page(0)
      const extract = AutoThrow(
        await api.extract_page(
          handle,
          0 as PageNumber,
          highest_obj_num,
          bytes_written,
          BigInt(FLUSH_THRESHOLD)
        )
      )

      highest_obj_num = extract.highest_obj_num
      bytes_written += extract.bytes_written

      yield { extract, order: page_number }
    } finally {
      await close()
    }
  }
}

export const PDFMerge: PDFMergeFunction = pages =>
  ProvisionWasm(api => Recompose(ExtractPages(api, pages)))
